<table mat-table [dataSource]="subscriptionModels" class="table-list">
    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let subscriptionModel">
            {{ subscriptionModel.id }}
        </td>
    </ng-container>

    <ng-container matColumnDef="sender_email">
        <th mat-header-cell *matHeaderCellDef>User</th>
        <td mat-cell *matCellDef="let subscriptionModel">
            {{ subscriptionModel.sender_email }}
        </td>
    </ng-container>

    <ng-container matColumnDef="plan">
        <th mat-header-cell *matHeaderCellDef>Plan</th>
        <td mat-cell *matCellDef="let subscriptionModel">
            {{ subscriptionModel.plan_label }} ({{
                subscriptionModel.subscription_plan
            }})
        </td>
    </ng-container>

    <ng-container matColumnDef="started_at">
        <th mat-header-cell *matHeaderCellDef>Started At</th>
        <td mat-cell *matCellDef="let subscriptionModel">
            {{ subscriptionModel.started_at | date_date_time }}
        </td>
    </ng-container>

    <ng-container matColumnDef="expires_at">
        <th mat-header-cell *matHeaderCellDef>Expires At</th>
        <td mat-cell *matCellDef="let subscriptionModel">
            <span *ngIf="subscriptionModel.expires_at">{{
                subscriptionModel.expires_at | date_date_time
            }}</span>
            <span *ngIf="!subscriptionModel.expires_at">None</span>
        </td>
    </ng-container>

    <ng-container matColumnDef="cancelled_at">
        <th mat-header-cell *matHeaderCellDef>Cancelled At</th>
        <td mat-cell *matCellDef="let subscriptionModel">
            <span *ngIf="subscriptionModel.cancelled_at">{{
                subscriptionModel.cancelled_at | date_date_time
            }}</span>
            <span *ngIf="!subscriptionModel.cancelled_at">Never</span>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnHeadings"></tr>
    <tr mat-row *matRowDef="let row; columns: columnHeadings"></tr>
</table>

<div>
    <mat-paginator
        [length]="pagingItemCount"
        [pageSize]="pagingPageSize"
        showFirstLastButtons
    >
    </mat-paginator>
</div>
